import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Title from 'shared/components/title/Title';
import confirmDiscardChanges from 'shared/components/confirm-discard-changes/confirmDiscardChanges';
import CheckBox from 'shared/components/check-box/CheckBox';
import Loader from 'features/Loader/Loader';
import WorkoutItem from 'features/work-out/components/workoutItem';
import { AuthContext } from 'features/auth/context/Auth';
import { Formik, Form } from 'formik';
import { getClient } from 'features/clientProfile/ducks/clientProfileActions';
import {
  getWorkouts,
  assignClientToWorkouts
} from 'features/work-out/ducks/workoutActions.js';

const WorkoutAssign = props => {
  const clientId = props.match.params.client_id;
  const { currentUser } = useContext(AuthContext) || {};

  let {
    client,
    workouts,
    assignClientToWorkouts,
    history,
    loadingWorkouts,
    loadingClient
  } = props;

  useEffect(() => {
    props.getClient(clientId, history);
    props.getWorkouts(currentUser.uid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  let workoutsList =
    workouts &&
    workouts.filter(workout => {
      return workout.clients_id && !workout.clients_id.includes(clientId);
    });

  if (loadingWorkouts || loadingClient) {
    return <Loader />;
  }

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        workoutsIds: []
      }}
      onSubmit={values => {
        return (
          client &&
          values.workoutsIds.length &&
          assignClientToWorkouts(client, values.workoutsIds, history)
        );
      }}
    >
      {formik => (
        <Form>
          {formik.isSubmitting ? (
            <Loader />
          ) : (
            <div className="client-form-pages">
              <div className="container">
                <Breadcrumb>
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href={`/clients/${clientId}`}>
                    {client && `${client.first_name} ${client.last_name}`}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>Assign Workkouts</Breadcrumb.Item>
                </Breadcrumb>
                <Title
                  pageTitle="Assign Workouts"
                  linkText="Cancel"
                  buttonText={workoutsList.length > 0 && 'Save'}
                  cancelLink={`/clients/${clientId}`}
                  cancelBtn={
                    formik.dirty &&
                    (() =>
                      confirmDiscardChanges(`/clients/${clientId}`, history))
                  }
                  disabled={!formik.values.workoutsIds.length}
                />

                <div className="assign-page">
                  <ul className="grid-list">
                    {workoutsList.length > 0 ? (
                      workoutsList.map(workout => {
                        return (
                          workout && (
                            <li key={workout.id}>
                              <CheckBox
                                key={workout.id}
                                value={workout.id}
                                name="workoutsIds"
                                id={workout.id}
                              />
                              <WorkoutItem
                                title={workout.name}
                                desc={`${workout.level} Phase ${workout.phase}`}
                                LinkTo={`/workouts/${workout.id}`}
                              />
                            </li>
                          )
                        );
                      })
                    ) : (
                      <h3>There is no Workouts for assigning!</h3>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Form>
      )}
    </Formik>
  );
};

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    loadingClient: state.clientProfileReducer.loading,
    workouts: state.workoutReducer.workouts,
    loadingWorkouts: state.workoutReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getWorkouts: trainerId => dispatch(getWorkouts(trainerId)),
    assignClientToWorkouts: (client, workoutsIds, history) =>
      dispatch(assignClientToWorkouts(client, workoutsIds, history))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkoutAssign);
